export const DEFAULT_PAGE = 1;
export const MAX_VISIBLE_PAGES = 5;
